/* The Mat Group - Lift Mat measurement + enquiry experience (product handle 'lift-mat' only).
   Standalone: does not depend on the "Enquiry" tag mechanism or the B2B wholesale cookie, so it
   renders and works identically in retail and B2B browsing. Submits straight to the same B2B
   enquiry relay every other product enquiry uses (webhook tmg-b2b-enquiry) - same info@ inbox,
   HubSpot ticket/contact/note treatment, dedupe and bot guard as normal. */
(function(){
  var CTA = document.getElementById('lift-mat-cta');
  var STAGE = document.getElementById('lift-mat-stage');
  if (!CTA || !STAGE) return;

  var LM_LETTERS = ['a','b','c','d','e','f','g','h'];
  var LM_MIN = 1, LM_MAX = 20000;
  var RELAY_URL = 'https://thematgroup.app.n8n.cloud/webhook/tmg-b2b-enquiry';
  var BOT_SECRET = 'tmg-b2b-3195-guard';
  var opened = null;

  function $(id){ return document.getElementById(id); }

  function hideNative(){
    document.querySelectorAll('.enquire--button').forEach(function(el){ var w = el.closest('.productitem--action') || el; w.style.display = 'none'; });
    var fs = document.querySelectorAll('form[data-product-form]');
    for (var i = 0; i < fs.length; i++) {
      var f = fs[i];
      var vu = f.querySelector('[data-variants-ui]'); if (vu) vu.style.display = 'none';
      var a = f.querySelector('[data-product-atc]'); if (a) { (a.closest('.product-form--atc') || a).style.display = 'none'; }
      var pb = f.querySelector('.shopify-payment-button'); if (pb) pb.style.display = 'none';
      var qw = f.querySelector('[data-quantity-wrapper]'); if (qw) qw.style.display = 'none';
    }
    /* Shopify's native local-pickup availability widget ("Pickup available at ... View store
       information") renders independently of the buy box/form and isn't covered by anything
       above - it makes no sense on a made-to-order, enquiry-only product. */
    document.querySelectorAll('[data-surface-pick-up]').forEach(function(el){ el.style.display = 'none'; });
    var po = document.getElementById('product-options'); if (po) po.style.display = 'none';
    var eo = document.getElementById('enquiry-options'); if (eo) eo.style.display = 'none';
    /* The B2B wholesale panel (tmg-b2b.liquid) mounts on every product regardless of handle -
       this experience already covers the same ground (measurements, notes, same enquiry
       pipeline) so hide its generic bulk-pricing panel here rather than showing both. */
    var b2bPanel = document.querySelector('.tmg-b2b-panel'); if (b2bPanel) b2bPanel.style.display = 'none';
  }

  /* ---------- measurement validation ---------- */
  function lmField(letter){ return $('lm-' + letter); }
  function lmErr(letter){ return $('lm-' + letter + '-err'); }
  function lmCheckOne(letter){
    var el = lmField(letter); if (!el) return null;
    var raw = el.value.trim();
    var num = raw === '' ? NaN : Number(raw);
    var ok = raw !== '' && !isNaN(num) && num >= LM_MIN && num <= LM_MAX;
    return { el: el, raw: raw, num: num, ok: ok };
  }
  function lmShowError(letter, msg){
    var e = lmErr(letter), el = lmField(letter);
    if (e) e.textContent = msg || '';
    if (el) el.classList.toggle('lm-invalid', !!msg);
  }
  function lmUpdateProgress(){
    var p = $('lm-progress'); if (!p) return;
    var filled = 0;
    LM_LETTERS.forEach(function(l){ var c = lmCheckOne(l); if (c && c.ok) filled++; });
    p.textContent = filled + ' of 8 measurements entered';
    p.classList.toggle('lm-progress-done', filled === 8);
  }
  function lmValidateMeasurements(showErrors){
    var firstInvalid = null, values = {}, allOk = true;
    LM_LETTERS.forEach(function(letter){
      var c = lmCheckOne(letter);
      if (!c) { allOk = false; return; }
      if (!c.ok) {
        allOk = false;
        if (!firstInvalid) firstInvalid = c.el;
        if (showErrors) lmShowError(letter, c.raw === '' ? 'Enter this measurement' : 'Enter a number between ' + LM_MIN + ' and ' + LM_MAX);
      } else {
        if (showErrors) lmShowError(letter, '');
        values[letter] = c.num;
      }
    });
    return { valid: allOk, values: values, firstInvalid: firstInvalid };
  }

  /* ---------- contact validation ---------- */
  function fieldErr(id, msg){
    var e = $(id + '-err'), el = $(id);
    if (e) e.textContent = msg || '';
    if (el) el.classList.toggle('lm-invalid', !!msg);
  }
  function validateContact(){
    var firstname = $('lm-firstname').value.trim();
    var lastname = $('lm-lastname').value.trim();
    var email = $('lm-email').value.trim();
    var phone = $('lm-phone').value.trim();
    var zip = $('lm-zip').value.trim();
    var industry = $('lm-industry').value;
    var firstInvalid = null, ok = true;
    function bad(id, cond, msg, el){ if (cond) { ok = false; fieldErr(id, msg); if (!firstInvalid) firstInvalid = el || $(id); } else { fieldErr(id, ''); } }
    bad('lm-firstname', !firstname, 'Enter your first name');
    bad('lm-lastname', !lastname, 'Enter your last name');
    bad('lm-email', !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email), 'Enter a valid email');
    bad('lm-phone', !phone, 'Enter a phone number');
    bad('lm-zip', !/^\d{4}$/.test(zip), 'Enter a 4-digit postcode');
    bad('lm-industry', !industry, 'Select an industry');
    return { valid: ok, firstInvalid: firstInvalid, values: { firstname: firstname, lastname: lastname, email: email, phone: phone, zip: zip, industry: industry, company: $('lm-company').value.trim() } };
  }

  /* ---------- bot token (matches Bot Guard in the B2B enquiry relay) ---------- */
  function djb2(s){ var x = 5381; for (var i = 0; i < s.length; i++) { x = ((x << 5) + x + s.charCodeAt(i)) >>> 0; } return x.toString(36); }
  function botToken(){ var ts = Date.now(); return ts + '.' + djb2(ts + ':' + BOT_SECRET); }

  /* ---------- step navigation ---------- */
  function showStep(name){
    ['measure', 'contact', 'success'].forEach(function(s){ $('lms-step-' + s).hidden = (s !== name); });
    var box = STAGE.querySelector('.lms-box'); if (box) box.scrollTop = 0;
  }
  function openStage(){
    opened = Date.now();
    STAGE.hidden = false;
    showStep('measure');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ var a = lmField('a'); if (a) a.focus(); }, 50);
  }
  function closeStage(){
    STAGE.hidden = true;
    document.body.style.overflow = '';
  }

  function lmInitDiagramZoom(){
    var fig = STAGE.querySelector('.lm-diagram'); if (!fig) return;
    var img = fig.querySelector('img'); if (!img) return;
    function open(){
      var ov = document.createElement('div'); ov.className = 'lm-zoom-modal';
      ov.innerHTML = '<button type="button" class="lm-zoom-x" aria-label="Close">&times;</button><img src="' + img.src + '" alt="' + img.alt.replace(/"/g, '&quot;') + '">';
      document.body.appendChild(ov);
      ov.addEventListener('click', function(e){ if (e.target === ov || e.target.classList.contains('lm-zoom-x')) ov.remove(); });
      document.addEventListener('keydown', function esc(e){ if (e.key === 'Escape') { ov.remove(); document.removeEventListener('keydown', esc); } });
    }
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', open);
    var btn = fig.querySelector('.lm-diagram-zoom'); if (btn) btn.addEventListener('click', open);
  }

  function submitEnquiry(measure, contact){
    var btn = $('lms-submit'); btn.disabled = true; btn.textContent = 'Sending…';
    var props = {};
    var labels = { a: 'A - Door opening (mm)', b: 'B - Wall left of door (mm)', c: 'C - Left side wall (mm)', d: 'D - Back wall (mm)', e: 'E - Right side wall (mm)', f: 'F - Wall right of door (mm)', g: 'G - Right-side protruding wall (mm)', h: 'H - Left-side protruding wall (mm)' };
    LM_LETTERS.forEach(function(l){ props[labels[l]] = String(measure.values[l]); });
    var notes = $('lm-notes').value.trim();
    var payload = {
      fields: {
        firstname: contact.firstname, lastname: contact.lastname, email: contact.email,
        phone: contact.phone, company: contact.company, zip: contact.zip,
        industry_type: contact.industry, message: notes
      },
      items: [{ sku: '', title: 'Lift Mat', qty: '1', size: '', opts: '', url: window.location.href, props: props }],
      page: window.location.href,
      bot: { hp: $('lm-hp').value, tok: botToken(), dt: Date.now() - (opened || Date.now()) }
    };
    fetch(RELAY_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function(){ showStep('success'); })
      .catch(function(){ showStep('success'); })
      .finally(function(){ btn.disabled = false; btn.textContent = 'Send enquiry'; });
  }

  function mountCta(){
    /* Move the trigger card to sit in the exact spot every other configurator/option box
       mounts (right before the native buy box), instead of wherever the template happens
       to render it in the page flow. Sibling, not child, of the form: a b2b-mode CSS rule
       hides form[data-product-form] itself, and nesting inside it would hide this too. */
    var f = document.querySelector('form[data-product-form]');
    if (f && f.parentNode) { f.parentNode.insertBefore(CTA, f); }
  }

  function init(){
    mountCta();
    /* Move the overlay to a direct child of body: some ancestor between the product-info
       column and body creates its own stacking context, which traps z-index:100000 below
       the sticky header instead of covering it. Appending to body guarantees it competes
       for stacking at the root, matching how the diagram lightbox and the generic enquiry
       modal already do this elsewhere in this theme. */
    document.body.appendChild(STAGE);
    hideNative();
    setTimeout(hideNative, 800);
    setTimeout(hideNative, 2200);

    $('lmc-open').addEventListener('click', openStage);
    $('lms-close').addEventListener('click', closeStage);
    STAGE.addEventListener('click', function(e){ if (e.target === STAGE) closeStage(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !STAGE.hidden) closeStage(); });

    LM_LETTERS.forEach(function(letter){
      var el = lmField(letter); if (!el) return;
      el.addEventListener('blur', function(){ var c = lmCheckOne(letter); lmShowError(letter, c.ok ? '' : (c.raw === '' ? '' : 'Enter a number between ' + LM_MIN + ' and ' + LM_MAX)); });
      el.addEventListener('input', function(){ if (el.classList.contains('lm-invalid')) lmShowError(letter, ''); lmUpdateProgress(); });
    });
    lmUpdateProgress();
    lmInitDiagramZoom();

    $('lms-to-contact').addEventListener('click', function(){
      var v = lmValidateMeasurements(true);
      lmUpdateProgress();
      if (!v.valid) { if (v.firstInvalid) { v.firstInvalid.focus(); v.firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' }); } return; }
      showStep('contact');
      setTimeout(function(){ var fn = $('lm-firstname'); if (fn) fn.focus(); }, 50);
    });
    $('lms-back').addEventListener('click', function(){ showStep('measure'); });
    $('lms-submit').addEventListener('click', function(){
      var measure = lmValidateMeasurements(false);
      var contact = validateContact();
      if (!contact.valid) { if (contact.firstInvalid) { contact.firstInvalid.focus(); contact.firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' }); } return; }
      submitEnquiry(measure, contact.values);
    });
    $('lms-done').addEventListener('click', closeStage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
